import React from "react";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";
import {
  canTriggerSearchSubmit,
  shouldAutoClearSearch,
} from "../../../utils/searchFieldUtils";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  flexGrow: 1,
  minWidth: 0,
  display: "flex",
  alignItems: "center",
  backgroundColor: "#F5F7F8",
  border: "1px solid rgba(0,0,0,0.05)",
  borderRadius: "8px",
  width: "100%",
  height: "40px",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  zIndex: 2,
  height: "40px",
  width: "25px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  [theme.breakpoints.up("sm")]: {
    width: "40px",
  },
}));

const StyledSearchIcon = styled(SearchIcon)(({ theme }) => ({
  backgroundColor: "#C93312",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  borderRadius: "8px",
  fontSize: "20px",
  padding: "5px",
  color: "#fff",
  boxSizing: "border-box",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "#AAACAC",
  width: "100%",
  position: "relative",
  zIndex: 1,
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    paddingRight: "calc(25px + 12px)",
    fontSize: "14px",
    lineHeight: 1.4,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      paddingRight: `calc(38px + ${theme.spacing(1)})`,
      fontSize: "15px",
    },
  },
}));

export const SearchBar = ({
  search,
  setSearch,
  appliedSearch = "",
  onApply,
  placeholder = "Search Mockups",
  loading = false,
}) => {
  const canSubmit = canTriggerSearchSubmit(search);

  const handleSubmit = () => {
    if (!canSubmit || loading) return;
    onApply(search.trim());
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setSearch(newValue);
    if (shouldAutoClearSearch(newValue, appliedSearch)) {
      onApply("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Search>
      <StyledInputBase
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        value={search}
        placeholder={placeholder}
        inputProps={{ "aria-label": "search" }}
        disabled={loading}
      />
      <SearchIconWrapper
        onClick={handleSubmit}
        role="button"
        tabIndex={0}
        aria-label="Search"
        aria-busy={loading}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleSubmit();
          }
        }}
        style={{ cursor: loading ? "default" : "pointer" }}
      >
        {loading ? (
          <div
            style={{
              backgroundColor: "#C93312",
              height: "100%",
              width: "100%",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={18} thickness={5} sx={{ color: "#fff" }} />
          </div>
        ) : (
          <StyledSearchIcon />
        )}
      </SearchIconWrapper>
    </Search>
  );
};
